import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators as bind } from 'redux';

import Flow from '../components/shared/MasterFlow';
import { mp, getCampaign, getCookie, getUtmVarsFromEncodedUri } from '../constants/utils';
import { Retirement } from '../data/ducks';
import { RetirementQuestionnaire } from '../constants/questionnaires';

const RetirementSteps = [Flow];

const FLOW_ID = 'Retiro';

const retirementQuestionnaire = [
  {
    label: '',
    value: FLOW_ID,
    questions: RetirementQuestionnaire,
  },
];

class RetirementContainer extends Component {
  state = {
    currentStep: 0,
    totalSteps: RetirementSteps.length,
  };

  componentDidMount = () => {
    mp(`[${getCampaign(window.location.href)}] | ${FLOW_ID} | Inicia`);
  };

  componentWillMount = () => {
    this.setState({ questionnaire: retirementQuestionnaire });
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.result.result.status === 200) {
      if (nextProps.result.result.data.pensionsMod40) {
        this.props.history.push(
          `/retiro/res/73/${nextProps.result.result.data.uuid}${
            this.props.match.params.referralId ? `/${this.props.match.params.referralId}` : ''
          }`,
        );
      } else {
        this.props.history.push(`/retiro/res/${nextProps.result.result.data.uuid}`);
      }
    } else {
      this.props.history.push(`error/${nextProps.result.status}`);
    }
  };

  nextStep = () => {
    const { currentStep, totalSteps } = this.state;
    if (currentStep < totalSteps - 1) {
      this.setState((state) => ({ currentStep: state.currentStep + 1 }));
    }
  };

  handleStepSubmit = (data) => {
    switch (this.state.currentStep) {
      case 0:
        mp(`[${getCampaign(window.location.href)}] | Retiro | Obtener resultados`);
        if (typeof data[0].email === 'undefined') {
          data[0].emailTest = 'undefined';
        } else if (data[0].email == null) {
          data[0].emailTest = null;
        } else {
          data[0].emailTest = data[0].email;
        }
        const campaign_url = getCookie('__gtm_campaign_url');
        let utm_vars = {};
        if (campaign_url) {
          utm_vars = getUtmVarsFromEncodedUri(campaign_url);
        }
        this.props.calculateRetirement({
          ...data[0],
          ...utm_vars,
        });
        break;
      default:
        break;
    }
    this.nextStep();
  };

  render() {
    const { currentStep, questionnaire } = this.state;
    const CurrentFlow = RetirementSteps[currentStep];
    return (
      <Fragment>
        <CurrentFlow
          flowTitle="Calculadora de retiro"
          flowId={FLOW_ID}
          nextStep={this.nextStep}
          onStepSubmit={this.handleStepSubmit}
          questionnaire={questionnaire}
        />
      </Fragment>
    );
  }
}

RetirementContainer.propTypes = {
  result: PropTypes.object,
  calculateRetirement: PropTypes.func,
};

RetirementContainer.defaultProps = {
  result: {},
  calculateRetirement: () => {},
};

const mapStateToProps = (state) => ({
  result: state.retirement.result,
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      calculateRetirement: Retirement.Creators.calculateRetirementRequested,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(RetirementContainer);
